// Module
var code = "<div class=\"module-error\"> <div class=\"dt-content\" ng-if=\"model.loading\"> <span class=\"ERROR_TIP\" ng-bind=\"i18n('notify.openPage')\"></span> </div> <div class=\"dt-content\" ng-if=\"!model.loading\"> <div class=\"errorIcon\"></div> <div class=\"errorTitle\" ng-bind=\"i18n('notify.closeSecondBefore')\"></div> <div class=\"errorContent\" ng-bind=\"i18n('notify.closePage')\"></div> </div> </div> <iframe id=\"notify_result\" name=\"notify_result\" width=\"0\" height=\"0\" border=\"0\"></iframe> <form id=\"notify_form\" method=\"POST\" target=\"notify_result\"> <input type=\"hidden\" name=\"bindRequest\" id=\"bindRequest\"/> <input type=\"hidden\" name=\"Signature\" id=\"Signature\"/> <input type=\"hidden\" name=\"SigAlg\" id=\"SigAlg\"/> </form>";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./public/hws/js/notify/views/content.html
// module id = 247
// module chunks = 0